import { faGlassMartiniAlt } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import '../styles/App.css';

const Resume = () => {

  return (
    <div id = 'about-info'>
      <h2>LORRI ANN ROMESBERG, MSW, JD</h2>
      <p className = 'center-paragraph'>
        Attorney, social worker, and self-taught web developer. 
        With the assistance of The Odin Project, experience includes Javascript, HTML, CSS, React, NodeJS, and Express.
      </p>
      <h4>Education</h4>
      <h5>THE ODIN PROJECT, 2019-2021</h5>
      <p>Full Stack Web Development</p>
      <ul>
        <li>Full stack includes Javascript, HTML, CSS, NodeJS.</li>
        <li>Community led, self-taught web development course.</li>
      </ul>
      <h5>SUFFOLK UNIVERSITY, Boston, MA - 1999 </h5>
      <p>Juris Doctorate magna cum laude, top 15% of class</p>
      <ul>Academic Achievements: 
        <li>Suffolk University Law Review, Staff Member 1998-1999</li>
        <li>Jurisprudence Award for Best Income Tax 1997-1998</li>
        <li>Distinguished Oral Advocate, Legal Practice Skills Section, 1996</li>
        <li>Dean’s List 1995-1999</li>
      </ul>
      <h5>BOSTON UNIVERSITY, Boston, MA	1993</h5>
      <p>Master of Social Work -</p>
      <p>Individual and Family Therapy Track</p>
      <p>Courses:  Child therapy, adolescent therapy, research and statistics.</p>
      <h5>CORNELL UNIVERSITY, Ithaca, NY	1992</h5>
      <p>Bachelor of Science in Human Service Studies/Social Work</p>
      <p>Concentration:  Adolescent Programs and Policies.</p>

      <h4>Professional Experience</h4>

      <h5>GIRL SCOUTS AND SCOUTS BSA, Rockford, MI	2007-present</h5>
	  <p>Volunteer: Service Unit Treasurer, Leader, Advancement Chair</p>
      <ul><li>
          Managed the Girl Scout service unit bank accounts, reviewed and compiled financial statements for 
          troops in 5 towns. Planned and facilitated regular Girl Scout meetings, managed regular outings 
          and events for up to 200 people. Managed Boy Scout troop advancements, conducted regular advancement 
          ceremonies, planned multi-day trips for groups.
      </li></ul>
      <h5>WEST VIRGINIA JUNIOR COLLEGE, Charleston, WV	2004</h5>
	  <p>Instructor, Legal Assistant Studies</p>
      <ul><li>
        Conducted classes in criminal law, legal research and writing, and law office management. 
        Prepared lectures and exams, corrected written assignments, and facilitated discussions.      
      </li></ul>
      <h5>LORRI ANN ROMESBERG, LICSW, JD, ATTORNEY AT LAW, Quincy, MA	2000–2003</h5>
	  <p>Sole Practitioner</p>
      <ul><li>
        Represented clients in care and protection, guardianship, CHINS, and divorce proceedings. 
        Conducted trials on issues of termination of parental rights, guardianships, parental unfitness, 
        adoption, and child custody.  This included preparing and arguing motions, researching relevant 
        legal issues, providing written reports to court, and composing legal briefs. Acted as guardian
        ad litem for children as investigator, next friend, and educational advocate.
      </li></ul>

      <h5>MASSACHUSETTS JUVENILE COURTS, Eastern Region, MA	1999–2000</h5>
	  <p>Judicial Law Clerk</p>
      <ul><li>
        Prepared findings of facts and conclusions of law on motions to suppress, motions to dismiss, 
        care and protection petitions, and petitions to dispense with parent’s consent to adoption. 
        Conducted legal research on criminal, procedural, and child custody issues and prepared legal 
        memoranda addressing legal questions. Observed court proceedings, hearings, and jury trials. 
        Orally presented research to other law clerks and administrative staff.
      </li></ul>

      <h5>MASSACHUSETTS SOCIETY FOR THE PREVENTION OF CRUELTY TO CHILDREN, Framingham, MA 1996–1999 </h5>
      <p>Clinic Director, 1998-1999</p>
      <ul><li>
          Supervised administrative and clinical work of clinicians and hired new staff. 
          Managed state and charitable contracts. Coordinated activities of sexual abuse team, 
          adoption team, and home-based team, and participated in multidisciplinary teams. Reviewed 
          sexual abuse evaluations and testified as expert witness in juvenile court. Coordinated 
          statewide quality circle that established sexual abuse evaluation training program.</li>
      </ul>
	  <p>Sexual Abuse Treatment Team Clinician, 1996-1998</p>
      <ul><li>
        Prepared adult and adolescent sexual offender evaluations for probation and department of social services. Facilitated weekly groups for adult male sex offenders and adolescent sex offenders. Provided sex offender specific treatment and individual and family psychotherapy to adults, adolescents, and children.  Prepared parenting evaluations for department of social services and developed and facilitated parenting skills group.
    </li></ul>
    <h5>CENTER FOR HEALTH AND HUMAN SERVICES, INC., New Bedford, MA	1993–1998</h5>
    <p>Parenting Assessment Coordinator, 1995-1998</p>
    <ul><li>
      Coordinated juvenile court clinic and department of social services parenting evaluations. 
      Assigned and reviewed those prepared by clinicians and prepared own, as well as court clinic 
      and substance abuse evaluations for court. Testified as expert witness in parenting assessments.
    </li></ul>
	<p>Clinical Social Worker, 1993-1998</p>
    <ul><li>
      Provided individual and family psychotherapy to children, adolescents, adults, and families, 
      both clinic- and home-based.
    </li></ul>
    <p>Crisis Clinician, 1993-1996</p>
    <ul><li>
      Assessed adolescents and children for risk of suicidality and homicidality. Facilitated 
      appropriate treatment interventions and provided short-term crisis counseling.
    </li></ul>
	<p>Head Start Mental Health Consultant, 1994-1998</p>
    <ul><li>
      Consulted with teachers about classroom behavior and facilitated parenting group. Provided 
      individual treatment and assessment. Assisted in development of mental health program and 
      organized workshops for teachers and parents.
    </li></ul>
	<p>Council for Children Subcommittee Chair</p>
    <ul><li>
      Served as human rights officer and performed parent/child mediations.
    </li></ul>

    <h4>Publications</h4>
    <ul><li>
      “Common Law Adoption:  An Argument for Statutory Recognition of Non-parent Caregiver Visitation,” 
      33 Suffolk University Law Review, 163, Suffolk University Press, 1999
    </li></ul>

    <h4>Presentations</h4>
    <ul>
    <li>“Signs and Symptoms of Sexual Abuse,” Kid’s Net Foster Parent Training, Weymouth, MA, 1999.</li>
    </ul>
    <h4>Professional Affiliations</h4>
    <ul>
      <li>Massachusetts Bar, Member, 1999–Present.</li>
    </ul>
    <h4>Certifications/Licensure</h4>
    <ul>
      <li>Licensed Independent Clinical Social Worker, Massachusetts, 1995–Present.</li>
      <li>Massachusetts Bar is law license.</li>
    </ul>

    <p>Excellent references will be provided on request.</p>
    </div>
  );
}

export default Resume;

